// extracted by mini-css-extract-plugin
module.exports = {"contents":"contents_contents__2oGVb"};